import { flattenArray, flattenObject } from "./dataFlatteners";
import { saveFileWithPicker } from "./fileManagerFunctions";

export function downloadSingleFile ({ fileType = "txt", fileName = "download-file", fileContent = "" }) {
    let formattedContent;

    // Conditional for converting the file content to string
    if (typeof fileContent !== "string") {
        if (Array.isArray(fileContent)) formattedContent = flattenArray(fileContent);
        else if (!fileContent && typeof fileContent === "object") formattedContent = flattenObject(fileContent);
        else formattedContent = "";
    } else {
        formattedContent = fileContent;
    }

    saveFileWithPicker(fileContent, `${fileName}.${fileType}`);
};